var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-header"},[_c('b-row',[_c('b-col',{staticClass:"title_PPage"},[_c('PIcon',{attrs:{"icon":_vm.icon,"size":27,"color":"#FFD102"}}),_c('span',{staticClass:"header-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1),_c('b-row',[_c('b-col',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }